import { render, staticRenderFns } from "./MainManage.vue?vue&type=template&id=0b0321d5&scoped=true&"
import script from "./MainManage.vue?vue&type=script&lang=ts&"
export * from "./MainManage.vue?vue&type=script&lang=ts&"
import style0 from "./MainManage.vue?vue&type=style&index=0&id=0b0321d5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0321d5",
  null
  
)

export default component.exports